'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

export default function SearchBar({ onSearch, placeholder = "Search technical resources..." }: SearchBarProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useState(() => {
    setIsHydrated(true);
  });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (isHydrated) {
      onSearch(searchQuery);
    }
  };

  if (!isHydrated) {
    return (
      <div className="relative">
        <div className="h-14 bg-input rounded-lg border border-border"></div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSearch} className="relative">
      <div className="relative">
        <Icon
          name="MagnifyingGlassIcon"
          size={20}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-technical-gray"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={placeholder}
          className="w-full h-14 pl-12 pr-32 bg-input text-foreground font-body text-sm rounded-lg border border-border focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20 transition-all duration-300"
        />
        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 px-6 py-2 bg-accent text-primary font-cta text-xs rounded-lg hover:bg-accent/80 transition-all duration-300"
        >
          SEARCH
        </button>
      </div>
    </form>
  );
}